import { useSearch } from "@tanstack/react-router";

import { FundraiserConnectPage } from "@/pages/FundraiserConnect";

export function FundraiserConnectRouteComponent() {
  const { fundraiser_connect_requests_id } = useSearch({
    from: "/_public/fundraiser-connect",
  });

  return <FundraiserConnectPage connectRequestId={fundraiser_connect_requests_id} />;
}
